// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_yM0","cls2":"Header-cls2_I_j Header-cls1_yM0"};